// extracted by mini-css-extract-plugin
export var infoRow = "_sr-2";
export var labelContainer = "_sr-0";
export var rightInfo = "_sr-1";